
import { Tabs } from "antd";
import SubscriptionPlans from "./SubscriptionPlans";
import AuditLogs from "./AuditLogs";

const SubscriptionWithAuditTabs = () => {
  return (
    <Tabs
      defaultActiveKey="plans"
      destroyInactiveTabPane
      items={[
        {
          key: "plans",
          label: "Subscription Plans",
          children: <SubscriptionPlans />,
        },
        {
          key: "audit",
          label: "Audit Logs",
          children: <AuditLogs />,
        },
      ]}
    />
  );
};

export default SubscriptionWithAuditTabs;
